export default {
  publicUrl: process.env.PUBLIC_URL,
  apiUrl: process.env.REACT_APP_API_URL || "http://localhost:8000",
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || "ssgyms.auth0.com",
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || "https://ssgyms",
    namespace:
      process.env.REACT_APP_AUTH0_NAMESPACE ||
      "https://startingstrengthgyms.com",
    redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI
  },
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID || ""
};
